module.exports = __webpack_public_path__ + "static/media/church7.6a6cb053.jpg";